import { imagesWEBP } from "./webpImages";

export const BrandMiniVehicleData = {
  dairy: [
    {
      id: 1,
      name: "Mahindra",
      brand: "Mahindra",
      image: imagesWEBP?.mahindraMilk,
      logo: `${process.env.NEXT_PUBLIC_CDN_LINK}v2/Vehicles/mahidra_logo.webp `,
      range: "85",
      emi: "11,450",
      cta: "",
    },
    {
      id: 2,
      name: "Piaggio",
      brand: "Piaggio",
      image: imagesWEBP?.piaggioMilk,
      logo: `${process.env.NEXT_PUBLIC_CDN_LINK}vehicleBrandLogos/avif/piaggio_logo.avif`,
      range: "80",
      emi: "12,600",
      cta: "",
    },

    {
      id: 3,
      name: "Etrio",
      brand: "Etrio",
      image: imagesWEBP?.etrioMilk,
      logo: `${process.env.NEXT_PUBLIC_CDN_LINK}vehicleBrandLogos/png/Frame.png`,
      range: "92",
      emi: "14,100",
      cta: "",
    },
    // {
    //   id: 4,
    //   name: "OSM",
    //   brand: "OSM",
    //   image: imagesWEBP?.osmMilk,
    //   logo: `${process.env.NEXT_PUBLIC_CDN_LINK}vehicleBrandLogos/avif/Group-1000004749.avif`,
    //   range: "87",
    //   emi: "13,800",
    //   cta: "",
    // },
    {
      id: 5,
      name: "Euler",
      brand: "Euler",
      image: imagesWEBP?.eulerMilk,
      logo: `${process.env.NEXT_PUBLIC_CDN_LINK}v2/Vehicles/euler_logo.webp`,
      range: "95",
      emi: "16,200",
      cta: "",
    },

    {
      id: 6,
      name: "neEV",
      brand: "Altigreen",
      image: imagesWEBP?.AltiGreen?.altigreenVehicle,
      logo: `${process.env.NEXT_PUBLIC_CDN_LINK}v2/Vehicles/altigreenlogo.webp`,
      range: "120",
      emi: "14369",
      cta: "",
    },
    {
      id: 7,
      name: "eltra",
      brand: "Greaves",
      image: imagesWEBP?.greaves?.greavesVehicle,
      logo: `${process.env.NEXT_PUBLIC_CDN_LINK}v2/Vehicles/brandLogo/greaveslogo.webp`,
      range: "105",
      emi: "13902",
      cta: "",
    },
  ],
  twoto3w: [
    {
      id: 1,
      name: "Mahindra",
      brand: "Mahindra",
      image: imagesWEBP?.mahindra3w11k,
      logo: `${process.env.NEXT_PUBLIC_CDN_LINK}v2/Vehicles/mahidra_logo.webp `,
      range: "153",
      emi: "14,754",
      cta: "",
    },
    {
      id: 2,
      name: "Piaggio",
      brand: "Piaggio",
      image: imagesWEBP?.piaggio3w11k,
      logo: `${process.env.NEXT_PUBLIC_CDN_LINK}vehicleBrandLogos/avif/piaggio_logo.avif`,
      range: "120",
      emi: "14,565",
      cta: "",
    },

    // {
    //   id: 3,
    //   name: "Etrio",
    //   brand: "Etrio",
    //   image: imagesWEBP?.etrio3w11k,
    //   logo: `${process.env.NEXT_PUBLIC_CDN_LINK}vehicleBrandLogos/png/Frame.png`,
    //   range: "150",
    //   emi: "16,200",
    //   cta: "",
    // },
    // {
    //   id: 4,
    //   name: "OSM",
    //   brand: "OSM",
    //   image: imagesWEBP?.Osm2w,
    //   logo: `${process.env.NEXT_PUBLIC_CDN_LINK}vehicleBrandLogos/avif/Group-1000004749.avif`,
    //   range: "120",
    //   emi: "12,791",
    //   cta: "",
    // },
    {
      id: 5,
      name: "Euler",
      brand: "Euler",
      image: imagesWEBP?.euler3w11k,
      logo: `${process.env.NEXT_PUBLIC_CDN_LINK}v2/Vehicles/euler_logo.webp`,
      range: "120",
      emi: "14,100",
      cta: "",
    },
    // {
    //   id: 6,
    //   name: "neEV",
    //   brand: "Altigreen",
    //   image: imagesWEBP?.AltiGreen?.altigreenVehicle,
    //   logo: `${process.env.NEXT_PUBLIC_CDN_LINK}v2/Vehicles/altigreenlogo.webp`,
    //   range: "120",
    //   emi: "14369",
    //   cta: "",
    // },
    {
      id: 7,
      name: "eltra",
      brand: "Greaves",
      image: imagesWEBP?.greaves3w11k,
      logo: `${process.env.NEXT_PUBLIC_CDN_LINK}v2/Vehicles/brandLogo/greaveslogo.webp`,
      range: "105",
      emi: "13,902",
      cta: "",
    },
  ],
  twoto3wGoodCommerical: [
    {
      id: 1,
      name: "Mahindra",
      brand: "Mahindra",
      image: imagesWEBP?.mahindra3w11k,
      logo: `${process.env.NEXT_PUBLIC_CDN_LINK}v2/Vehicles/mahidra_logo.webp`,
      range: "153",
      emi: "14,754",
      cta: "",
      isOpenPopUp: true,
      headingText: "Get exciting offers on Mahindra loading tempo",
      CTAText: "Get offer",
      hindiHeadingText:"पाएं Mahindra कार्गो EV पर आकर्षक डील",
      hindiCTAText:"Turno एक्सपर्ट से बात करें ",
    },
    {
      id: 2,
      name: "Piaggio",
      brand: "Piaggio",
      image: imagesWEBP?.piaggio3w11k,
      logo: `${process.env.NEXT_PUBLIC_CDN_LINK}vehicleBrandLogos/avif/piaggio_logo.avif`,
      range: "120",
      emi: "14,565",
      cta: "",
      isOpenPopUp: true,
      headingText: "Get exciting offers on Piaggio loading tempo",
      CTAText: "Get offer",
      hindiHeadingText:"पाएं Piaggio कार्गो EV पर आकर्षक डील",
      hindiCTAText:"Turno एक्सपर्ट से बात करें ",
    },
    {
      id: 3,
      name: "Euler",
      brand: "Euler",
      image: imagesWEBP?.euler3w11k,
      logo: `${process.env.NEXT_PUBLIC_CDN_LINK}v2/Vehicles/euler_logo.webp`,
      range: "120",
      emi: "14,100",
      cta: "",
      isOpenPopUp: true,
      headingText: "Get exciting offers on Euler loading tempo",
      CTAText: "Get offer",
      hindiHeadingText:"पाएं Euler कार्गो EV पर आकर्षक डील",
      hindiCTAText:"Turno एक्सपर्ट से बात करें ",
    },
    {
      id: 4,
      name: "eltra",
      brand: "Greaves",
      image: imagesWEBP?.greaves3w11k,
      logo: `${process.env.NEXT_PUBLIC_CDN_LINK}v2/Vehicles/brandLogo/greaveslogo.webp`,
      range: "105",
      emi: "13,902",
      cta: "",
      isOpenPopUp: true,
      headingText: "Get exciting offers on Greaves loading tempo",
      CTAText: "Get offer",
      hindiHeadingText:"पाएं Greaves कार्गो EV पर आकर्षक डील",
      hindiCTAText:"Turno एक्सपर्ट से बात करें",
    },
  ],
  passengerVehicles: [
    {
      id: 1,
      name: "Montra Super Auto",
      brand: "Montra",
      image: imagesWEBP?.montraSuperAuto,
      logo: `${process.env.NEXT_PUBLIC_CDN_LINK}v2/Vehicles/montra/others/montra_logo.webp`,
      vehicle_id: "super-auto",
      range: "160",
      emi: "",
      cta: "",
      isPassenger: true,
      headingText: "Get attractive offers on Montra passenger EV ",
      CTAText: "Talk to a Turno expert now",
      hindiHeadingText: "पाएं Montra पैसेंजर EV पर आकर्षक ऑफर ",
      hindiCTAText: "जानने के लिए Turno एक्सपर्ट से बात करें",
      kannadaHeadingText:"Montra ಆಟೋ ಮೇಲೆ ಆಕರ್ಷಕ ಕೊಡುಗೆಗಳನ್ನು ಪಡೆಯಿರಿ",
      kannadaCTAText:"ಈಗಲೇ ನಮ್ಮೊಂದಿಗೆ ಮಾತಾಡಿ",
    },
    {
      id: 2,
      name: "Bajaj Passenger EV",
      brand: "Bajaj",
      image: imagesWEBP?.bajajPassenger,
      logo: `${process.env.NEXT_PUBLIC_CDN_LINK}v2/Vehicles/Bajaj/logo/bajaj_logo.webp`,
      range: "178",
      emi: "",
      cta: "",
      isPassenger: true,
      headingText: "Get attractive offers on Bajaj passenger EV ",
      CTAText: "Talk to a Turno expert now",
      vehicle_id:"re-e-tec",
      hindiHeadingText: "पाएं Bajaj पैसेंजर EV पर आकर्षक ऑफर",
      hindiCTAText: "जानने के लिए Turno एक्सपर्ट से बात करें",
      kannadaHeadingText:"Bajaj ಆಟೋ ಮೇಲೆ ಆಕರ್ಷಕ ಕೊಡುಗೆಗಳನ್ನು ಪಡೆಯಿರಿ",
      kannadaCTAText:"ಈಗಲೇ ನಮ್ಮೊಂದಿಗೆ ಮಾತಾಡಿ",
    },
    {
      id: 3,
      name: "Mahindra Tero",
      brand: "Mahindra",
      image: imagesWEBP?.mahindraTreo,
      logo: `${process.env.NEXT_PUBLIC_CDN_LINK}v2/Vehicles/mahidra_logo.webp`,
      range: "150",
      emi: "",
      cta: "",
      isPassenger: true,
      headingText: "Get attractive offers on Mahindra passenger EV ",
      CTAText: "Talk to a Turno expert now",
      vehicle_id:"treo-plus",
      hindiHeadingText: "पाएं Mahindra पैसेंजर EV पर आकर्षक ऑफर",
      hindiCTAText: "जानने के लिए Turno एक्सपर्ट से बात करें",
      kannadaHeadingText:"Mahindra ಆಟೋ ಮೇಲೆ ಆಕರ್ಷಕ ಕೊಡುಗೆಗಳನ್ನು ಪಡೆಯಿರಿ",
      kannadaCTAText:"ಈಗಲೇ ನಮ್ಮೊಂದಿಗೆ ಮಾತಾಡಿ",
    },
    {
      id: 4,
      name: "Piaggio Passenger EV",
      brand: "Piaggio",
      image: imagesWEBP?.piaggioPassenger,
      logo: `https://assets.turnoclub.com/developer/offer-turno-images/S3/vehicleBrandLogos/avif/piaggio_logo.avif`,
      range: "110",
      emi: "",
      cta: "",
      isPassenger: true,
      headingText: "Get attractive offers on Piaggio passenger EV ",
      CTAText: "Talk to a Turno expert now",
      vehicle_id: "ape-e-city-fx",
      headingText: "",
      CTAText : "",
      headingText: "Get attractive offers on Piaggio passenger EV ",
      CTAText: "Talk to a Turno expert now",
      hindiHeadingText: "पाएं Piaggio पैसेंजर EV पर आकर्षक ऑफर",
      hindiCTAText: "जानने के लिए Turno एक्सपर्ट से बात करें",
      kannadaHeadingText:"Piaggio ಆಟೋ ಮೇಲೆ ಆಕರ್ಷಕ ಕೊಡುಗೆಗಳನ್ನು ಪಡೆಯಿರಿ",
      kannadaCTAText:"ಈಗಲೇ ನಮ್ಮೊಂದಿಗೆ ಮಾತಾಡಿ",
    },
  ],
  catering: [
    {
      id: 1,
      name: "Mahindra",
      brand: "Mahindra",
      image: imagesWEBP?.homeZor_Grand,
      logo: `${process.env.NEXT_PUBLIC_CDN_LINK}v2/Vehicles/mahidra_logo.webp `,
      range: "85",
      emi: "11,450",
      cta: "",
    },
    {
      id: 2,
      name: "Piaggio",
      brand: "Piaggio",
      image: imagesWEBP?.homePiaggio,
      logo: `${process.env.NEXT_PUBLIC_CDN_LINK}vehicleBrandLogos/avif/piaggio_logo.avif`,
      range: "80",
      emi: "12,600",
      cta: "",
    },

    {
      id: 3,
      name: "Etrio",
      brand: "Etrio",
      image: imagesWEBP?.homeEtrio,
      logo: `${process.env.NEXT_PUBLIC_CDN_LINK}vehicleBrandLogos/png/Frame.png`,
      range: "92",
      emi: "14,100",
      cta: "",
    },
    {
      id: 4,
      name: "OSM",
      brand: "OSM",
      image: imagesWEBP?.homeOsm,
      logo: `${process.env.NEXT_PUBLIC_CDN_LINK}vehicleBrandLogos/avif/Group-1000004749.avif`,
      range: "87",
      emi: "13,800",
      cta: "",
    },
    {
      id: 5,
      name: "Euler",
      brand: "Euler",
      image: imagesWEBP?.Euler?.eulerVehicle1,
      logo: `${process.env.NEXT_PUBLIC_CDN_LINK}v2/Vehicles/euler_logo.webp`,
      range: "95",
      emi: "16,200",
      cta: "",
    },
    {
      id: 6,
      name: "neEV",
      brand: "Altigreen",
      image: imagesWEBP?.AltiGreen?.altigreenVehicle,
      logo: `${process.env.NEXT_PUBLIC_CDN_LINK}v2/Vehicles/altigreenlogo.webp`,
      range: "120",
      emi: "14369",
      cta: "",
    },
    {
      id: 7,
      name: "eltra",
      brand: "Greaves",
      image: imagesWEBP?.greaves?.greavesVehicle,
      logo: `${process.env.NEXT_PUBLIC_CDN_LINK}v2/Vehicles/brandLogo/greaveslogo.webp`,
      range: "105",
      emi: "13902",
      cta: "",
    },
  ],

  freedom: [
    {
      id: 1,
      name: "Mahindra",
      brand: "Mahindra",
      image: imagesWEBP?.MahindraF,
      logo: `${process.env.NEXT_PUBLIC_CDN_LINK}v2/Vehicles/mahidra_logo.webp `,
      range: "153",
      emi: "14,754",
      cta: "",
    },
    {
      id: 2,
      name: "Piaggio",
      brand: "Piaggio",
      image: imagesWEBP?.PiaggioF,
      logo: `${process.env.NEXT_PUBLIC_CDN_LINK}vehicleBrandLogos/avif/piaggio_logo.avif`,
      range: "120",
      emi: "14,565",
      cta: "",
    },

    {
      id: 3,
      name: "Etrio",
      brand: "Etrio",
      image: imagesWEBP?.EtrioF,
      logo: `${process.env.NEXT_PUBLIC_CDN_LINK}vehicleBrandLogos/png/Frame.png`,
      range: "150",
      emi: "16,200",
      cta: "",
    },
    {
      id: 4,
      name: "OSM",
      brand: "OSM",
      image: imagesWEBP?.OSMf,
      logo: `${process.env.NEXT_PUBLIC_CDN_LINK}vehicleBrandLogos/avif/Group-1000004749.avif`,
      range: "120",
      emi: "12,791",
      cta: "",
    },
    {
      id: 5,
      name: "Euler",
      brand: "Euler",
      image: imagesWEBP?.EulerF,
      logo: `${process.env.NEXT_PUBLIC_CDN_LINK}v2/Vehicles/euler_logo.webp`,
      range: "120",
      emi: "14,100",
      cta: "",
    },
    {
      id: 6,
      name: "neEV",
      brand: "Altigreen",
      image: imagesWEBP?.AltiGreen?.altigreenVehicle,
      logo: `${process.env.NEXT_PUBLIC_CDN_LINK}v2/Vehicles/altigreenlogo.webp`,
      range: "120",
      emi: "14369",
      cta: "",
    },
    {
      id: 7,
      name: "eltra",
      brand: "Greaves",
      image: imagesWEBP?.greaves?.greavesVehicle,
      logo: `${process.env.NEXT_PUBLIC_CDN_LINK}v2/Vehicles/brandLogo/greaveslogo.webp`,
      range: "105",
      emi: "13902",
      cta: "",
    },
  ],
  newPassengerVehicles: [
    {
      id: 1,
      name: "Mahindra Treo Plus",
      brand: "Mahindra",
      image: imagesWEBP?.mahindraTreoPlus,
      logo: `${process.env.NEXT_PUBLIC_CDN_LINK}v2/Vehicles/mahidra_logo.webp`,
      range: "150",
      emi: "",
      cta: "",
      isPassenger: true,
      headingText: "Get attractive offers on Mahindra passenger EV ",
      CTAText: "Talk to a Turno expert now",
      vehicle_id:"treo-plus",
      hindiHeadingText: "पाएं Mahindra पैसेंजर EV पर आकर्षक ऑफर",
      hindiCTAText: "जानने के लिए Turno एक्सपर्ट से बात करें",
      kannadaHeadingText:"Mahindra ಆಟೋ ಮೇಲೆ ಆಕರ್ಷಕ ಕೊಡುಗೆಗಳನ್ನು ಪಡೆಯಿರಿ",
      kannadaCTAText:"ಈಗಲೇ ನಮ್ಮೊಂದಿಗೆ ಮಾತಾಡಿ",
    },
    {
      id:2,
      name: "TVS King EV Max",
      brand: "TVS",
      image: imagesWEBP?.tvsKingMaxPassenger,
      logo: `${process.env.NEXT_PUBLIC_CDN_LINK}logos/brands/tvs_logo.svg`,
      range :"179",
      emi: "",
      cta: "",
      isPassenger: true,
      headingText: "Get attractive offers on TVS passenger EV ",
      CTAText: "Talk to a Turno expert now",
      vehicle_id:"TVSKingEVMax",
      hindiHeadingText: "पाएं TVS पैसेंजर EV पर आकर्षक ऑफर",
      hindiCTAText: "जानने के लिए Turno एक्सपर्ट से बात करें",
      kannadaHeadingText:"TVS ಆಟೋ ಮೇಲೆ ಆಕರ್ಷಕ ಕೊಡುಗೆಗಳನ್ನು ಪಡೆಯಿರಿ",
      kannadaCTAText:"ಈಗಲೇ ನಮ್ಮೊಂದಿಗೆ ಮಾತಾಡಿ",
    },
    {
      id: 3,
      name: "Bajaj RE E-TEC 9.0",
      brand: "Bajaj",
      image: imagesWEBP?.bajajRec,
      logo: `${process.env.NEXT_PUBLIC_CDN_LINK}v2/Vehicles/Bajaj/logo/bajaj_logo.webp`,
      range: "178",
      emi: "",
      cta: "",
      isPassenger: true,
      headingText: "Get attractive offers on Bajaj passenger EV ",
      CTAText: "Talk to a Turno expert now",
      vehicle_id:"re-e-tec",
      hindiHeadingText: "पाएं Bajaj पैसेंजर EV पर आकर्षक ऑफर",
      hindiCTAText: "जानने के लिए Turno एक्सपर्ट से बात करें",
      kannadaHeadingText:"Bajaj ಆಟೋ ಮೇಲೆ ಆಕರ್ಷಕ ಕೊಡುಗೆಗಳನ್ನು ಪಡೆಯಿರಿ",
      kannadaCTAText:"ಈಗಲೇ ನಮ್ಮೊಂದಿಗೆ ಮಾತಾಡಿ",
    },
    {
      id: 4,
      name: "Piaggio Ape E City",
      brand: "Piaggio",
      image: imagesWEBP?.piaggioEcity,
      logo: `https://assets.turnoclub.com/developer/offer-turno-images/S3/vehicleBrandLogos/avif/piaggio_logo.avif`,
      range: "110",
      emi: "",
      cta: "",
      isPassenger: true,
      headingText: "Get attractive offers on Piaggio passenger EV ",
      CTAText: "Talk to a Turno expert now",
      vehicle_id: "ape-e-city-fx",
      headingText: "",
      CTAText : "",
      headingText: "Get attractive offers on Piaggio passenger EV ",
      CTAText: "Talk to a Turno expert now",
      hindiHeadingText: "पाएं Piaggio पैसेंजर EV पर आकर्षक ऑफर",
      hindiCTAText: "जानने के लिए Turno एक्सपर्ट से बात करें",
      kannadaHeadingText:"Piaggio ಆಟೋ ಮೇಲೆ ಆಕರ್ಷಕ ಕೊಡುಗೆಗಳನ್ನು ಪಡೆಯಿರಿ",
      kannadaCTAText:"ಈಗಲೇ ನಮ್ಮೊಂದಿಗೆ ಮಾತಾಡಿ",
    },
    {
      id: 5,
      name: "Montra Super Auto",
      brand: "Montra",
      image: imagesWEBP?.montraSuperAutoNew,
      logo: `${process.env.NEXT_PUBLIC_CDN_LINK}v2/Vehicles/montra/others/montra_logo.webp`,
      vehicle_id: "super-auto",
      range: "160",
      emi: "",
      cta: "",
      isPassenger: true,
      headingText: "Get attractive offers on Montra passenger EV ",
      CTAText: "Talk to a Turno expert now",
      hindiHeadingText: "पाएं Montra पैसेंजर EV पर आकर्षक ऑफर ",
      hindiCTAText: "जानने के लिए Turno एक्सपर्ट से बात करें",
      kannadaHeadingText:"Montra ಆಟೋ ಮೇಲೆ ಆಕರ್ಷಕ ಕೊಡುಗೆಗಳನ್ನು ಪಡೆಯಿರಿ",
      kannadaCTAText:"ಈಗಲೇ ನಮ್ಮೊಂದಿಗೆ ಮಾತಾಡಿ",
    },
    {
      id : 6,
      name: "Osm Stream City Qik",
      brand: "Osm",
      image: imagesWEBP?.osmQikPassenger,
      logo: `${process.env.NEXT_PUBLIC_CDN_LINK}logos/brands/osm_logo.svg`,
      range: "126",
      emi: "",
      cta: "",
      isPassenger: true,
      headingText: "Get attractive offers on Osm passenger EV ",
      CTAText: "Talk to a Turno expert now",
      vehicle_id: "OsmStreamCityQik",
      hindiHeadingText: "पाएं Osm पैसेंजर EV पर आकर्षक ऑफर",
      hindiCTAText: "जानने के लिए Turno एक्सपर्ट से बात करें",
      kannadaHeadingText:"Osm ಆಟೋ ಮೇಲೆ ಆಕರ್ಷಕ ಕೊಡುಗೆಗಳನ್ನು ಪಡೆಯಿರಿ",
      kannadaCTAText:"ಈಗಲೇ ನಮ್ಮೊಂದಿಗೆ ಮಾತಾಡಿ",
    }
  ],
};
